export const APP_VERSION = import.meta.env.PACKAGE_VERSION;
export const DISCORD_LINK = "https://discord.movie-web.app";
export const GITHUB_LINK = "https://github.com/movie-web/movie-web";
export const GA_ID = "G-KD8BVGX987";
export const DONATION_LINK = "https://ko-fi.com/movieweb";
export const BACKEND_URL = "https://backend.movie-web.app";
